import '@/store/api/product-inventory/typedefs'
import api from '@/store/api/product-inventory'
import * as mutationTypes from './mutation-types'
import {formatNumber} from '@/store/utils'
import {mapProduct} from '@/store/modules/product-inventory/products'

const initialState = () => ({
    product: {}
})

const state = initialState()

export default {
    namespaced: true,
    state,
    getters: {
        product: state => state.product,
        productFormatted: state => ({
            ...state.product,
            service_sell: formatNumber(state.product.service_sell),
            connection_sell: formatNumber(state.product.connection_sell),
            service_cost: formatNumber(state.product.service_cost),
            connection_cost: formatNumber(state.product.connection_cost),
            product_category_id: (state.product.product_category && state.product.product_category.id) || undefined,
            product_type_id: (state.product.product_type && state.product.product_type.id) || undefined,
            inventory_type_id: (state.product.inventory_type && state.product.inventory_type.id) || undefined,
            product_status_id: (state.product.product_status && state.product.product_status.id) || undefined
        })
    },
    actions: {
        /**
         * @param {ProductQuery} data
         * @returns {Promise<*>}
         */
        showProduct: async ({commit, dispatch}, data) => {
            try {
                const response = await api.products.showProduct(data)
                commit(mutationTypes.SET_PRODUCT, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {ProductInventoryItem} data
         * @returns {Promise<*>}
         */
        createProduct: async ({dispatch}, data) => {
            try {
                return await api.products.createProduct(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {ProductInventoryItem} data
         * @returns {Promise<*>}
         */
        updateProduct: async ({dispatch}, data) => {
            try {
                return await api.products.updateProduct(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {ProductInventoryItem} data
         * @returns {Promise<*>}
         */
        removeProduct: async ({dispatch}, data) => {
            try {
                return await api.products.removeProduct(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetProduct: async ({commit}) => commit(mutationTypes.RESET_PRODUCT)
    },
    mutations: {
        [mutationTypes.SET_PRODUCT]: (state, data) => state.product = mapProduct(data),
        [mutationTypes.RESET_PRODUCT]: (state) => Object.assign(state, initialState())
    }
}
